async function getStep (userId) {
  const response = await window.fetch(`${process.env.PUBLIC_URL}/api/${userId}/current-step`)
  return response.json()
}

export default getStep
